module.exports = __webpack_public_path__ + "img/errorCode.d8a0b1de.png";